/**
 * Component Entry
 *
 */

import GlobalError from './GlobalError'
export default GlobalError
export * from './GlobalError'
